import { UserBrowser } from './user-browser';

export type { UserBrowser };

let _instance: UserBrowser | undefined;

export const getUserBrowser = (): UserBrowser => {
  if (!_instance) {
    _instance = new UserBrowser();
  }
  return _instance;
};
